export default __webpack_public_path__ + "static/media/expImgWhite.0b896d9c.svg";